import styled from "styled-components";

export const NomenclatureContainer = styled.div`
  padding: 27px 36px 23px 36px;
  height: auto;
  max-height: 330px;
  overflow: auto;
`;
